import { render, staticRenderFns } from "./WorkFlowHistoryActivity.vue?vue&type=template&id=3f4997cc&scoped=true"
import script from "./WorkFlowHistoryActivity.vue?vue&type=script&lang=js"
export * from "./WorkFlowHistoryActivity.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowHistoryActivity.vue?vue&type=style&index=0&id=3f4997cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4997cc",
  null
  
)

export default component.exports